<template>
  <section class="sm-list group-mail">
    <div class="sm-list-inner">
      <template v-if="!emptyState">
        <table v-if="viewPort == 'large'" class="sm-table sm-list__table">
          <thead class="sm-table__head">
            <tr class="sm-txt-upper">
              <th class="sm-table__head-item number">
                ID <include-svg :name="'icon-arrow-b-bold'" />
              </th>
              <th class="sm-table__head-item customer">
                {{provider.client_level != 1 ? 'Customer' : 'User'}} <include-svg :name="'icon-arrow-b-bold'" />
              </th>
              <th class="sm-table__head-item qty">Qty.</th>
              <th class="sm-table__head-item date">
                Created date <include-svg :name="'icon-arrow-b-bold'" />
              </th>
              <th class="sm-table__head-item date">
                Forwarded date <include-svg :name="'icon-arrow-b-bold'" />
              </th>                
              <th class="sm-table__head-item status">
                Status <include-svg :name="'icon-arrow-b-bold'" />
              </th>
              <th class="sm-table__head-item request">
                <span>Action</span>
              </th>
            </tr>
          </thead>
          <tbody>
            <group-mail 
              v-for="item in list" 
              :key="item.id"
              :item="item"
              @action="itemAction"
            />
          </tbody>
        </table>

        <div v-else class="sm-mobile-table sm-list__mobile">
          <div class="sm-mobile-table-item header">
            <div class="sm-mobile-table-item-row">
              <div class="sm-mobile-table-item-row-th customer">{{provider.client_level != 1 ? 'Customer' : 'User'}}</div>
              <div class="sm-mobile-table-item-row-th id sm-txt-center">ID</div>
              <div class="sm-mobile-table-item-row-th qty last">QTY.</div>
            </div>
          </div>
          <group-mail 
            v-for="item in list" 
            :key="item.id"
            :item="item"
            @action="itemAction"
          />
        </div>
      </template>
      <empty-mail 
        v-else 
        :tab="'new'"
      />
    </div>
  </section>
</template>

<script>
import GroupMail from '@/views/admin/pages/mail/components/GroupMail';
import EmptyMail from '@/components/mail/EmptyMail';
import Radiobutton from '@/components/Radiobutton';
import ViewPort from '@/mixins/ViewPort';
import { mapGetters } from 'vuex';

export default {
  name: 'group-maillist',
  components: {
    'group-mail': GroupMail,
    'empty-mail': EmptyMail,
    'radiobutton-block': Radiobutton
  },
  props: {
    list: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      emptyState: false,
      allowedBreakpoints: [
        'small',
        'large'
      ],
    };
  },
  computed: {
    ...mapGetters({
      provider: 'provider'
    })
  },
  mixins: [ViewPort],
  methods: {
    itemAction(data) {
      this.$emit('action', data);
    },
  }
}
</script>

<style lang="scss">
  @use '@/assets/scss/general/mixins.scss' as *;
  @use '@/assets/scss/framework/scss-variables.scss' as *;
  @use '@/assets/scss/pages/common/mail/_list.scss';
  .hintFade-enter,
  .hintFade-leave-to {
    opacity: 0;
  }
  .hintFade-enter-active {
    transition: opacity .2s;
  }
</style>